import { render, staticRenderFns } from "./SectionExpandable.vue?vue&type=template&id=03ef8f1d&scoped=true&"
import script from "./SectionExpandable.vue?vue&type=script&lang=ts&"
export * from "./SectionExpandable.vue?vue&type=script&lang=ts&"
import style0 from "./SectionExpandable.vue?vue&type=style&index=0&id=03ef8f1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ef8f1d",
  null
  
)

export default component.exports